import { action, computed, makeObservable, observable } from 'mobx';
import configKioskStore from '../../KioskConfigScreen/store';
import configMobileStore from '../../MobileConfigScreen/stores';
import configWebStore from '../../WebConfigScreen/stores';
import { CONSUMER_CHANNEL_CONFIGURATION_SCREEN, CONSUMER_CHANNEL_CONFIG_CRUMB, defaultConsumerChannelsConfigNavigationCrumbs } from '../constants';
import { IConsumerChannelsConfigCrumbs, IResponseConsumerChannelsConfig } from '../types';
import logger from '~/services/logger';
import { LoadingStatus } from 'src/types/main';
import client from 'src/services/client';
import dookConfigStore from '~/view/screens/SettingsScreen/screens/OrderingChannel/screens/DookConfigScreen/store';

class ConsumerChannelsConfigStore {
  private initial: boolean = true;

  constructor() {
    makeObservable(this);
  }

  @observable public loading: LoadingStatus = LoadingStatus.Init;

  @computed public get isFirstLoading(): boolean {
    return this.initial && this.loading === LoadingStatus.Loading;
  }

  @computed public get isLoading(): boolean {
    return [
      consumerChannelsConfigStore.loading,
      configMobileStore.loading,
      configWebStore.loading,
      configKioskStore.loading,
      dookConfigStore.loading,
    ].includes(LoadingStatus.Loading);
  }

  @observable public navigationCrumbs: IConsumerChannelsConfigCrumbs = defaultConsumerChannelsConfigNavigationCrumbs;
  @action public setNavigationCrumb = (crumb: CONSUMER_CHANNEL_CONFIG_CRUMB, screen: CONSUMER_CHANNEL_CONFIGURATION_SCREEN) => {
    this.navigationCrumbs = { ...this.navigationCrumbs, [screen]: crumb };
  };

  @action fetchParams = async () => {
    try {
      this.loading = LoadingStatus.Loading;

      const response: IResponseConsumerChannelsConfig = await client.get('/v3/settings/consumer-channels');
      configMobileStore.setData(response.mobile);
      configWebStore.setData(response.website);
      configKioskStore.setData(response.kiosk);
      dookConfigStore.setData(response.dook);

      this.initial = false;
      this.loading = LoadingStatus.Success;
    } catch (error: any) {
      this.loading = LoadingStatus.Error;
      logger.error({ error, place: 'ConsumerChannelsConfigStore fetchParams', showModal: true });
    }
  };

  public isNoColorsCrumb = (screen: CONSUMER_CHANNEL_CONFIGURATION_SCREEN): boolean => {
    return this.navigationCrumbs[screen] !== CONSUMER_CHANNEL_CONFIG_CRUMB.COLORS;
  };

  @action clearStore = () => {
    this.navigationCrumbs = defaultConsumerChannelsConfigNavigationCrumbs;
  };
}

const consumerChannelsConfigStore = new ConsumerChannelsConfigStore();

export default consumerChannelsConfigStore;
